import localforage from 'localforage';

const beforeEach = (to, from, next) => {
	localforage.getItem('authtoken').then((token) => {
		if (token && ['login', 'password.reset', 'password.forget'].includes(to.name)) {
            next({ name: 'admin.dashboard' });
            return;
		}


		if (to.meta.requiresAuth) {
			if (!token) {
				localforage.removeItem('authtoken');
				next({ name: 'login', query: { access: 'unauthorized' } });
				return;
			}
		}

		next();
	}).catch((error) => {
		next(); // Always call next() to proceed, even in case of error
	});
};

export default beforeEach;
